import {Box, Typography} from '@mui/material';
import {forgotPasswordModalStyles} from './ForgotPasswordStyle.styles';
import {H5, IMAGE_TABLE_ALT} from '@/utils/constants';
import sendEmailIcon from '@icons/send-mail.svg';
import Button from '@/shared/components/Button';

interface ForgotPasswordStep1Props {
	onCloseModal: () => void;
	handleSubmit: () => void;
	userEmail: string;
}
const ForgotPasswordStep2 = ({onCloseModal, handleSubmit, userEmail}: ForgotPasswordStep1Props) => {
	return (
		<Box sx={forgotPasswordModalStyles.content}>
			<Box sx={forgotPasswordModalStyles.iconWrap}>
				<img src={sendEmailIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={forgotPasswordModalStyles.contentWrap}>
				<Typography variant={H5} sx={forgotPasswordModalStyles.title}>
					Check Your Inbox
				</Typography>
				<Typography sx={forgotPasswordModalStyles.description}>Instructions have been sent to:</Typography>
				<Typography sx={forgotPasswordModalStyles.afterDescription}>{userEmail}</Typography>
			</Box>
			<Box sx={forgotPasswordModalStyles.btnWrap}>
				<Button sx={forgotPasswordModalStyles.btn} title="Try Again" onClick={handleSubmit} />
			</Box>
		</Box>
	);
};

export default ForgotPasswordStep2;
